
export const LoadingStyle = theme => ({
    appBar: {
        position: 'relative',
    },
    pageProgress: {
        color: '#353232',
        position: 'absolute',
        top: "calc(50% - 62px)",
        left: "calc(50% - 62px)"
    },
    progressUnit: {
        backgroundColor: theme.palette.background.paper,
    },
    progressContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`
    }
});

